export const paginationDefaultState = {
  page: 0,
  size: 10,
};
